import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of, switchMap, withLatestFrom } from 'rxjs';
import { DashboardService } from 'src/app/core/dashboard/dashboard.service';
import { IndexedDBService } from 'src/app/core/indexedDB/indexed-db.service';
import { AppStateInterface } from '../types';
import * as ProfileDataActions from './actions';
import { successProfileDataSelector } from './selectors';

@Injectable()
export class ProfileDataEffect {
  getProfileData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ProfileDataActions.getProfileData),
      withLatestFrom(this._store.select(successProfileDataSelector)),
      switchMap(([action, ProfileDataSuccess]) => {
        // if data is already fetched, avoid fetching again.
        if (ProfileDataSuccess) {
          return of(
            ProfileDataActions.getProfileDataSuccessAlreadyLoaded(
              ProfileDataSuccess,
            ),
          );
        }
        return this._dashboardService.getProfileData().pipe(
          map((profileData) => {
            return ProfileDataActions.getProfileDataSuccess(profileData);
          }),
          catchError((error) =>
            of(ProfileDataActions.getProfileDataFailure(error)),
          ),
        );
      }),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _dashboardService: DashboardService,
    private _indexedDbService: IndexedDBService,
    private _store: Store<AppStateInterface>,
  ) {}
}
